import classnames from "classnames";
import * as React from "react";
export default class WhiteSpace extends React.Component {
    render() {
        const { prefixCls, className, style, onClick } = this.props;
        const wrapCls = classnames(prefixCls, className);
        return <div className={wrapCls} style={style} onClick={onClick}/>;
    }
}
WhiteSpace.defaultProps = {
    prefixCls: "pm-whitespace",
    size: "md",
};
